// Faturamento Bruto: carteira de projetos/contratos por empresa (visão executiva,
// não escopada por departamento — mesmo público de Premissas de Faturamento).
// Espelha backend/config.py ROLES_FATURAMENTO_BRUTO / EMPRESAS_FATURAMENTO_BRUTO —
// mantenha os dois em sincronia.
export const ROLES_FATURAMENTO_BRUTO = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
export const EMPRESAS_FATURAMENTO_BRUTO = ["GT", "CRIA", "CIGTA", "FLOW"];
